import http from '../http'

export default {
    invitados(promotor) {
        return http.get(`/usuarios/${promotor}/red/invitados`)
    }
}